module.exports = __webpack_public_path__ + "static/img/job-description-generator.ac436a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/job-description-generator.png
// module id = K+El
// module chunks = 0